import { toast } from 'react-toastify';
import Toast from '../components/Toast';

const defaultConfig = {
  position: "bottom-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  className: "!p-0 !bg-transparent !shadow-none !backdrop-blur-none",
  closeButton: false,
};

const createToast = (type, message, details = '', config = {}) => {
  const finalConfig = {
    ...defaultConfig,
    ...config,
  };

  return toast(
    ({ closeToast }) => (
      <Toast
        type={type}
        message={message}
        details={details}
        onClose={closeToast}
        autoClose={finalConfig.autoClose}
      />
    ),
    finalConfig
  );
};

export const showToast = {
  success: (message, details = '', config = {}) => {
    return createToast('success', message, details, config);
  },

  error: (message, details = '', config = {}) => {
    const errorConfig = {
      autoClose: 7000,
      ...config,
    };
    return createToast('error', message, details, errorConfig);
  },

  warning: (message, details = '', config = {}) => {
    return createToast('warning', message, details, config);
  },

  info: (message, details = '', config = {}) => {
    return createToast('info', message, details, config);
  },

  promise: (promise, messages = {}, config = {}) => {
    const { pending, success, error } = {
      pending: 'Processing...',
      success: 'Completed successfully',
      error: 'An error occurred',
      ...messages,
    };

    return toast.promise(
      promise,
      {
        pending: {
          render: ({ closeToast }) => (
            <Toast
              type="info"
              message={pending}
              onClose={closeToast}
              autoClose={false}
            />
          ),
        },
        success: {
          render: ({ closeToast }) => (
            <Toast
              type="success"
              message={success}
              onClose={closeToast}
              autoClose={defaultConfig.autoClose}
            />
          ),
        },
        error: {
          render: ({ closeToast, data }) => (
            <Toast
              type="error"
              message={error}
              details={data?.message || 'Please try again'}
              onClose={closeToast}
              autoClose={7000}
            />
          ),
        },
      },
      {
        ...defaultConfig,
        ...config,
      }
    );
  },

  dismissAll: () => toast.dismiss(),
}; 